import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from '../../components/loader';
import AssetConfig from '../../components/assetconfig';

const qs = require('query-string');

class TradeInitial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enabledPairs: '',
      initialState: '',
      usePair: 'GOLDBTC',
      exchA: 'gold',
      exchB: 'btc',
    };
    this.getPairAssets = this.getPairAssets.bind(this);
    this.pairsInitial = this.pairsInitial.bind(this);
    this.stateSetup = this.stateSetup.bind(this);
    this.showPair = this.showPair.bind(this);
  }

  componentDidMount() {
    const { assets, pairs } = this.props;
    this.pairsInitial();
  }

  getPairAssets(pair) {
    const { pairs } = this.props;
    let altPair;
    let pairAssets;
    let useAssets;
    if (pairs && Object.keys(pairs).length) {
      if (pairs[pair] && pairs[pair].alt) {
        altPair = pairs[pair].alt;
      }
    }
    if (altPair) {
      pairAssets = altPair.split(':');
    }
    if (pairAssets && pairAssets.length && pairAssets[0] && pairAssets[1]) {
      useAssets = {
        exchA: pairAssets[0],
        exchB: pairAssets[1],
      };
    }
    return useAssets;
  }

  pairsInitial() {
    const { assets, pairs } = this.props;
    const limitPairs = {};
    if (pairs && Object.keys(pairs).length) {
      Object.keys(pairs).forEach((key) => {
        if (pairs[key] && pairs[key].permissions) {
          if (pairs[key].permissions.includes('LIMIT')) {
            limitPairs[key] = pairs[key];
          }
        }
      });
    }
    const enabledAssets = [];
    if ((AssetConfig && AssetConfig.length)) {
      AssetConfig.map((asset) => {
        if (asset.enabled) {
          enabledAssets.push(asset.handle);
        }
      });
    }
    const enabledPairs = [];
    if (limitPairs && Object.keys(limitPairs).length) {
      Object.keys(limitPairs).forEach((key) => {
        if (limitPairs[key] && limitPairs[key].alt) {
          const pairAssets = limitPairs[key].alt.split(':');

          let isEnabled;
          if (pairAssets && pairAssets.length) {
            isEnabled = pairAssets.every((asset) => enabledAssets.includes(asset));
          }
          if (isEnabled) {
            enabledPairs.push(key);
          }
        }
      });
    }
    const useState = this.stateSetup(enabledPairs);
    this.setState({
      filterParams: useState.filterParams,
      usePair: useState.pair,
      exchA: useState.exchA,
      exchB: useState.exchB,
      enabledPairs,
      initialSet: true,
    });
  }

  stateSetup(enabledPairs) {
    const filterParams = qs.parse(this.props.location.search);
    let exchA = 'gold';
    let exchB = 'btc';
    let filterPair;
    const defaultPair = 'GOLDBTC';
    let usePair;
    if (filterParams && filterParams.pair) {
      filterPair = filterParams.pair;
    }
    if (filterPair) {
      if (this.showPair(filterPair, enabledPairs)) {
        usePair = filterPair;
      } else {
        usePair = defaultPair;
        this.props.history.push({ search: '?pair=' + defaultPair });
      }
    } else {
      usePair = defaultPair;
    }
    const pairAssets = this.getPairAssets(usePair);
    if (pairAssets) {
      exchA = pairAssets.exchA;
      exchB = pairAssets.exchB;
    }
    const useState = {
      filterParams,
      pair: usePair || 'GOLDBTC',
      exchA: exchA || 'gold',
      exchB: exchB || 'btc',
    };
    return useState;
  }

  showPair(pair, directPairs) {
    const { enabledPairs } = this.state;
    let enabled;
    if (enabledPairs) {
      enabled = enabledPairs;
    }
    if (directPairs) {
      enabled = directPairs;
    }
    let pairEnabled;
    if (enabled && pair) {
      pairEnabled = enabled.includes(pair);
    }
    return pairEnabled;
  }

  render() {
    const { assets, pairs, location, history } = this.props;
    const { enabledPairs, filterParams, usePair, exchA, exchB, initialSet } = this.state;

    const tradeReady = initialSet && (pairs && Object.keys(pairs).length) && (assets && assets.length) && (enabledPairs && filterParams && usePair && exchA && exchB);

    if (tradeReady) {
      return (
        React.cloneElement(this.props.children, {
          enabledPairs,
          filterParams,
          usePair,
          exchA,
          exchB,
          location,
          history,
          getPairAssets: this.getPairAssets,
          showPair: this.showPair,
        })
      );
    }
    return (
      <div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="center-loader">
              <Loader logo />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
});

export default withRouter(connect(mapStateToProps)(TradeInitial));
